import { render, staticRenderFns } from "./EbRadio.vue?vue&type=template&id=10bf7a54&scoped=true"
import script from "./EbRadio.vue?vue&type=script&lang=js"
export * from "./EbRadio.vue?vue&type=script&lang=js"
import style0 from "./EbRadio.vue?vue&type=style&index=0&id=10bf7a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf7a54",
  null
  
)

export default component.exports